import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SetAppDriverList, GetAppDriverList } from "../../store/driverListAtom";


function UserDeliverySideBar({ onSelection, viewItemDetails }) {
 const setAppDriverListData = SetAppDriverList();
  const getAppDriverListData = GetAppDriverList();
  const { id } = useParams();





  const manageStatus = (statusCode, statusName) => {
    let defaultClass = 'text-blue-600';
    switch (statusCode) {
      case 1: defaultClass = 'text-green-600'; break;
      case 2: defaultClass = 'text-yellow-600'; break;
      case 3: defaultClass = 'text-red-600'; break;
      case 4: defaultClass = 'text-purple-600'; break;
      case 5: defaultClass = 'text-orange-600'; break;
      case 6: defaultClass = 'text-gray-600'; break;
      default: break;
    }
    return (
      <span className={`text-sm font-semibold ${defaultClass}`}>
        {statusName}
      </span>
    );
  };

  return (
    <section className="mt-4 border border-gray-200 rounded-lg bg-white shadow-sm">
      {getAppDriverListData?.user_info?.map((user, index) => (
        <div
          key={index}
          onClick={() => viewItemDetails(user?.user_id)}
          className={`flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-200 ${
            Number(id) === user?.user_id ? 'bg-blue-50' : ''
          }`}
        >
          <div className="flex items-center space-x-3 w-full">
         
            <div className="flex-1">
              <div className="font-semibold text-gray-800 text-sm">{user?.user_full_name}</div>
              <div className="text-sm text-gray-500 italic">{user?.user_email_address}</div>
              <div className="text-sm text-gray-600">{user?.user_mobile_number}</div>
            </div>
            <div className="text-sm font-semibold text-gray-700"> {manageStatus(user?.user_status_code, user?.user_status_name)}</div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default UserDeliverySideBar;